import { getUserToRequest } from "../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";

const loadActivityFeed = async ({ locals, load, req }, next) => {
  if (req.query.modal?.type === "activity-feed") {
    const { query = {} } = req;
    const {
      page = 0,
      sort = "newest",
      productType,
      actionTypes,
      clientId,
      athlete,
      isOwner,
    } = query;

    const pageSize = 50;
    if (!locals.allAthletesFromOrganization)
      await load("allAthletesFromOrganization");

    let queryToSend = {
      limit: pageSize + 1,
      skip: pageSize * page,
      sort: { timestamp: sort === "newest" ? -1 : 1 },
      userType: productType || undefined,
      actionTypes: actionTypes || undefined,
      clientId: clientId ? athlete : undefined,
      isOwner: isOwner || undefined,
    };

    const { activeUser, organizationOwner } = locals;
    const userIsCoach = activeUser.permissions.includes("coach");
    const userToRequest = userIsCoach
      ? getUserToRequest(activeUser, organizationOwner)
      : activeUser;
    //if it is a subcoach
    if (String(activeUser._id) !== String(userToRequest._id)) {
      //and in all list
      if (!productType) {
        queryToSend = {
          ...queryToSend,
          coachId: userToRequest._id,
          isPush: true,
          isPress: true,
        };
      }
      if (productType === "PUSH" || productType === "PRESS") {
        queryToSend = {
          ...queryToSend,
          coachId: userToRequest._id,
        };
      }
    }
    await load("activityFeed", queryToSend);

    return next();
  } else return next();
};

export default loadActivityFeed;
